import { SHOW_GROCERYLIST_LIMIT_NOTIFICATION } from './actionTypes';

export default (ingredients) => ({
  type: SHOW_GROCERYLIST_LIMIT_NOTIFICATION,
  payload: {
    ingredients
  }
});